module.exports = __webpack_public_path__ + "img/icon_data3.1d2b1363.svg";